import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Footer() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowCookieBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowCookieBanner(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const navigation = [
    { name: 'Inicio', href: '/' },
    { name: 'Empresa', href: '/empresa' },
    { name: 'Servicios', href: '/servicios' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Contacto', href: '/contacto' }
  ];

  return (
    <>
      <footer className="bg-gray-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                VaciadoPro Barcelona
              </h3>
              <div className="space-y-2 text-gray-300">
                <p className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  Barcelona, España
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  +34 690 22 09 44
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  info@vaciadopro.es
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
              <nav className="space-y-2">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="block text-gray-300 hover:text-green-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>
            </div>

            {/* Social Media & Contact */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Síguenos</h4>
              <div className="flex space-x-4 mb-6">
                <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://wa.me/34690220944" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors">
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
              <p className="text-sm text-gray-400">
                Servicio 24/7 en Barcelona y alrededores
              </p>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 VaciadoPro Barcelona | Todos los derechos reservados
            </p>
            <div className="flex flex-wrap gap-4 text-sm">
              <a href="/politica-privacidad" className="text-gray-400 hover:text-white">
                Política de Privacidad
              </a>
              <a href="/aviso-legal" className="text-gray-400 hover:text-white">
                Aviso Legal
              </a>
              <a href="/politica-cookies" className="text-gray-400 hover:text-white">
                Política de Cookies
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Cookie Banner */}
      {showCookieBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-gray-900/95 backdrop-blur-sm border-t border-gray-700 p-4 z-50">
          <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3 text-white">
              <i className="ri-information-line text-green-400 text-xl"></i>
              <p className="text-sm">
                Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Al continuar navegando, aceptas nuestro uso de cookies.
              </p>
            </div>
            <div className="flex gap-3 whitespace-nowrap">
              <button
                onClick={rejectCookies}
                className="px-4 py-2 text-sm border border-gray-600 text-gray-300 hover:bg-gray-800 rounded-lg transition-colors cursor-pointer"
              >
                Rechazar
              </button>
              <button
                onClick={acceptCookies}
                className="px-4 py-2 text-sm bg-green-600 text-white hover:bg-green-700 rounded-lg transition-colors cursor-pointer"
              >
                Aceptar Cookies
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 left-6 w-14 h-14 !bg-gray-800 hover:!bg-gray-700 !text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 z-50 cursor-pointer"
        aria-label="Volver arriba"
      >
        <i className="ri-arrow-up-line text-2xl"></i>
      </button>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/34690220944"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 z-50 cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-fill text-2xl"></i>
      </a>
    </>
  );
}
